import { Dispatch } from 'redux';

import { TemplatesFilterData } from '../../store/modules/filter';
import { templateActions } from '../../store/modules/template';

import getTemplateFiltersByQuery from './getTemplateFiltersByQuery';

export type TemplateListQuery = TemplatesFilterData & {
  title?: string;
  embed?: string;
  category?: string;
  pageNumber?: number;
  description?: string;
  templateName?: string;
};

type DispatchCurrentTemplateProps = {
  query: TemplateListQuery;
  dispatch: Dispatch;
};

const dispatchCurrentTemplate = ({
  query,
  dispatch
}: DispatchCurrentTemplateProps) => {
  const templateIdOrSlug = query.templateName;
  const templateListFilters = getTemplateFiltersByQuery(query);

  templateIdOrSlug &&
    dispatch(
      templateActions.fetchTemplateView({
        templateIdOrSlug,
        templateListFilters
      })
    );
};

export default dispatchCurrentTemplate;
